export type SaveStatus = "idle" | "saving" | "saved" | "error";
export type ActiveView =
  | { type: "content"; slug: string; label: string }
  | { type: "messages" }
  | { type: "leads" }
  | { type: "questionnaires" }
  | { type: "redirects" }
  | { type: "partners" }
  | { type: "videos" }
  | { type: "news" }
  | { type: "nova-deals" }
  | { type: "nova-header" }
  | { type: "nova-featured-offer" }
  | { type: "nova-perks" }
  | { type: "email-settings"; kind: "messages" | "leads" }
  | { type: "landing-pages" }
  | { type: "landing-page-editor"; slug: string };
export const CONTENT_PAGES = [
  { slug: "about", label: "About Us" },
  { slug: "loyalty", label: "Loyalty" },
  { slug: "promo-rewards", label: "Promo" },
  { slug: "benefits", label: "Benefits" },
  { slug: "digital-signage", label: "Digital Signage" },
  { slug: "music-audio-messaging", label: "Music & Audio Messaging" },
  { slug: "streamee", label: "Streamee" },
  { slug: "padu-app", label: "PADU App" },
  { slug: "retail-media", label: "Retail Media" },
];
export const HOME_PAGES = [
  { slug: "antamoivi", label: "Rewards" },
  { slug: "programmata-pistotitas", label: "Loyalty Programs" },
  { slug: "miniaies-klirosis", label: "Monthly Draws" },
];
export const LEGAL_PAGES = [
  { slug: "terms", label: "Terms of Service" },
  { slug: "privacy", label: "Privacy Policy" },
];
export const VIDEO_PAGES = [
  { slug: "padu-app", label: "PADU App" },
  { slug: "promo-rewards", label: "Promo" },
  { slug: "loyalty", label: "Loyalty" },
  { slug: "benefits", label: "Benefits" },
  { slug: "digital-signage", label: "Digital Signage" },
  { slug: "music-audio-messaging", label: "Music & Audio Messaging" },
  { slug: "retail-media", label: "Retail Media" },
];
export type FieldType =
  | "first_name"
  | "last_name"
  | "email"
  | "phone"
  | "multiple_select"
  | "multiple_choice"
  | "checkbox";
export const FIELD_TYPE_OPTIONS: { value: FieldType; label: string }[] = [
  { value: "first_name", label: "First name" },
  { value: "last_name", label: "Last name" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "multiple_select", label: "Multiple select (checkboxes)" },
  { value: "multiple_choice", label: "Multiple choice (single answer)" },
  { value: "checkbox", label: "Checkbox (e.g. accept terms)" },
];
export const CHOICE_FIELD_TYPES: FieldType[] = ["multiple_select", "multiple_choice"];
export type SectionType = "text" | "image" | "questionnaire" | "hero" | "steps" | "cards";
export interface QuestionnaireFieldDraft {
  id?: number;
  clientId: string;
  field_type: FieldType;
  label: string;
  required: boolean;
  options: string[];
  order: number;
}
export interface StepDraft {
  id?: number;
  clientId: string;
  text: string;
  order: number;
  icon_url?: string | null;
}
export interface CardDraft {
  id?: number;
  clientId: string;
  title: string;
  description: string;
  link_text: string;
  link_url: string;
  order: number;
  icon_url?: string | null;
}
export interface SectionDraft {
  id?: number;
  clientId: string;
  section_type: SectionType;
  order: number;
  heading: string;
  body: string;
  image_url?: string | null;
  button_text?: string;
  button_url?: string;
  questionnaire_fields: QuestionnaireFieldDraft[];
  steps: StepDraft[];
  cards: CardDraft[];
}
export interface LandingPageSummary {
  id: number;
  slug: string;
  title: string;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}
export interface LandingPageDetail extends LandingPageSummary {
  sections: SectionDraft[];
}
